// @ts-nocheck
import Env from "config/environment";
import Apps from "constants/applications";
import { CURRENT_PORTAL } from "constants/app_subdomains";

function initialize(segmentId?: string) {
  if (!segmentId) {
    return;
  }

  const analytics = (window.analytics = window.analytics || []);

  if (analytics.initialize) {
    return;
  } else if (analytics.invoked) {
    return console.error("Segment snippet included twice.");
  }

  analytics.invoked = true;
  analytics.methods = [
    "trackSubmit",
    "trackClick",
    "trackLink",
    "trackForm",
    "pageview",
    "identify",
    "reset",
    "group",
    "track",
    "ready",
    "alias",
    "debug",
    "page",
    "once",
    "off",
    "on",
    "addSourceMiddleware",
    "addIntegrationMiddleware",
    "setAnonymousId",
    "addDestinationMiddleware",
  ];
  analytics.factory = function (method) {
    return function () {
      const args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      analytics.push(args);
      return analytics;
    };
  };
  for (const method of analytics.methods) {
    analytics[method] = analytics.factory(method);
  }
  analytics.load = function (key, options) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = `https://cdn.segment.com/analytics.js/v1/${key}/analytics.min.js`;

    const [first] = document.getElementsByTagName("script");
    first.parentNode.insertBefore(script, first);
    analytics._loadOptions = options;
  };
  analytics._writeKey = segmentId;
  analytics.SNIPPET_VERSION = "4.15.2";
  analytics.load(segmentId);
}

// RSMB-472 track notary events separately
initialize(CURRENT_PORTAL === Apps.NOTARY ? Env.notarySegmentId : Env.segmentId);
